// extracted by mini-css-extract-plugin
export default {"root":"AHplzk","bg":"UJQjeD"};